import Alpine from 'alpinejs';

Alpine.store('zManager', {
    order: 999999000,

    next() {
        return this.order += 1;
    }
});
